import { render, staticRenderFns } from "./PodcastSection.vue?vue&type=template&id=0b98e6fa&scoped=true"
import script from "./PodcastSection.vue?vue&type=script&lang=js"
export * from "./PodcastSection.vue?vue&type=script&lang=js"
import style0 from "./PodcastSection.vue?vue&type=style&index=0&id=0b98e6fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b98e6fa",
  null
  
)

export default component.exports